import { PrimeIcons } from 'primereact/api';
import React from 'react';
import { ButtonClose, ButtonDelete } from '../../../components/Buttons';
import { ModalDialog } from '../../../components/ModalDialog';
import type { LanguageResponse } from '../../../../api';

export interface DeleteLanguageDialogProps {
    isVisible: boolean;
    onHide: () => void;
    handleDeleteLanguage: () => void | Promise<void>;
    language: LanguageResponse | null;
    processing: boolean;
}

export const DeleteLanguageDialog: React.FC<DeleteLanguageDialogProps> = ({
    isVisible,
    onHide,
    handleDeleteLanguage,
    language,
    processing
}) => {
    return (
        <ModalDialog
            visible={isVisible}
            header="Potvrďte smazání"
            style={{ width: 450 }}
            footer={
                <>
                    <ButtonClose label="Ne" onClick={onHide} disabled={processing} />
                    <ButtonDelete label="Ano" onClick={handleDeleteLanguage} rounded={false} disabled={processing} />
                </>
            }
            onHide={onHide}
        >
            {language && (
                <div className="dialog-text">
                    <span className="dialog-text__warning">
                        <i className={PrimeIcons.EXCLAMATION_TRIANGLE} />
                        <span>
                            Opravdu chcete smazat jazyk <b>{language.local_name}</b> (kód <b>{language.language_code}</b>)?
                        </span>
                    </span>

                    <span>
                        Po smazání jazyka dojde také ke smazání veškerých záznamů z překladových
                        tabulek pro tento jazyk.
                    </span>

                    <span>Tato akce je nevratná!</span>
                </div>
            )}
        </ModalDialog>
    );
};
